import { render, staticRenderFns } from "./CallSettings.vue?vue&type=template&id=489a22ff&scoped=true"
import script from "./CallSettings.vue?vue&type=script&lang=js"
export * from "./CallSettings.vue?vue&type=script&lang=js"
import style0 from "./CallSettings.vue?vue&type=style&index=0&id=489a22ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a22ff",
  null
  
)

export default component.exports